import { StepId } from '../../api/useRiskToleranceWorkflowQuery';

export interface FormValues {
  [StepId.IncomeStability]: number;
}

export const title = 'My current income and future income (salary, pension, etc...) is:';

export const options = [
  {
    label: 'Very secure/stable',
    value: 1,
  },
  {
    label: 'Mostly secure/stable',
    value: 2,
  },
  {
    label: 'Secure/stable',
    value: 3,
  },
  {
    label: 'Somewhat secure/stable',
    value: 4,
  },
  {
    label: 'Not secure/stable',
    value: 5,
  },
];
